require('./bootstrap');

import {createApp, h} from 'vue';
import {createInertiaApp} from '@inertiajs/inertia-vue3';
import {InertiaProgress} from '@inertiajs/progress';
import copyText from "@meforma/vue-copy-to-clipboard";
import Toaster from '@meforma/vue-toaster';

const appName = window.document.getElementsByTagName('title')[0]?.innerText || 'Referex';

createInertiaApp({
    title: (title) => `${title} - ${appName}`,
    resolve: (name) => {
        if (name.includes('/')) {
            console.log("this has been imported")
            return import(`./Pages/${name}.vue`);
        }
        else
            return require(`./Pages/${name}.vue`);
    },
    setup({el, app, props, plugin}) {
        return createApp({render: () => h(app, props)})
            .use(plugin)
            .use(copyText)
            .use(Toaster)
            .mixin({
                methods: {
                    route,
                    getPlanWeight(plan) {
                        switch (plan) {
                            case 'starter':
                                return 1;
                            case 'pro':
                                return 2;
                            case 'premium':
                                return 3
                            default:
                                return 1;
                        }
                    },
                    getPlanCampaignNumberLimit(plan) {
                        switch (plan) {
                            case 'starter':
                                return 3;
                            case 'pro':
                                return 10;
                            case 'premium':
                                return 10
                            default:
                                return 3;
                        }
                    },
                    getPlanCampaignReferrerNumberLimit(plan) {
                        switch (plan) {
                            case 'starter':
                                return 5;
                            case 'pro':
                                return 15;
                            case 'premium':
                                return 15
                            default:
                                return 5;
                        }
                    },
                    displayForSubscriptionPlan(grade) {
                        const plan = this.$inertia.page.props.current_subscription;
                        const current_plan_weight = this.getPlanWeight(plan);
                        const grade_plan_weight = this.getPlanWeight(grade);
                        return current_plan_weight >= grade_plan_weight;
                    },
                    canAddCampaignForPlan() {
                        const plan = this.$inertia.page.props.current_subscription;
                        const campaigns = this.$inertia.page.props.number_of_campaigns;
                        const grade_plan_max_campaigns = this.getPlanCampaignNumberLimit(plan);
                        return campaigns < grade_plan_max_campaigns;
                    },
                    canAddReferrerToCampaignForPlan(referrers_count) {
                        const plan = this.$inertia.page.props.current_subscription;
                        const grade_plan_max_campaign_referrers = this.getPlanCampaignReferrerNumberLimit(plan);
                        return referrers_count < grade_plan_max_campaign_referrers;
                    }
                }
            })
            .mount(el);
    },
})
;

InertiaProgress.init({color: '#3E13A5'});
